import { gql } from '@apollo/client'

export default gql`
  query GetOrbitalTrackSuggestFee($agingBuff: Float!, $currency: CurrencyCode) {
    getOrbitalTrackSuggestRentalFee(
      agingBuff: $agingBuff
      currencyCode: $currency
    ) {
      currencyCode
      currencyCodeDecimal
      price
    }
  }
`
